"use client";
import "./button.scss";
const Button = ({
  icon,
  type = "button",
  callback,
  children,
  isPrimary,
  maxWidth,
  selected = false,
  disabled = false,
}) => {
  const baseClass = isPrimary ? "primary-btn" : "secondary-btn";
  const selectedClass = selected ? "selected" : "";

  return (
    <button
      type={type}
      style={{ maxWidth: maxWidth ? maxWidth : "" }}
      className={`${baseClass} ${selectedClass}`}
      onClick={() => (callback ? callback() : null)}
      disabled={disabled}
    >
      {icon ? (
        <div className="interal-button-content">
          <img src={icon} alt="" />
          <span className="button-text">{children}</span>
        </div>
      ) : (
        <span className="button-text">{children}</span>
      )}
    </button>
  );
};

export default Button;
